import { FunctionComponent } from 'react';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import EnvelopeSentIcon from 'theme/icons/envelope-sent.svg';

import Button from 'components/layout/Button';
import { ButtonLayouts, ButtonSizes, ButtonStyles, ButtonVariants } from 'components/layout/Button/types';
import Image from 'components/layout/Image';

import StyledComponent from './styles';
import { Props } from './types';

export const MessageSent: FunctionComponent<Props> = ({ translations, setFormSubmitted }) => {
    const router = useRouter();

    const returnToHome = (): Promise<boolean> => router.push(Routes.PublicHome);

    const returnToForm = (): void => setFormSubmitted(false);

    return (
        <StyledComponent className='section-message-sent'>
            <div
                className='content-wrapper'
            >
                <div className='icon-wrapper'>
                    <Image
                        src={EnvelopeSentIcon}
                        layout="fixed"
                        width={105}
                        height={86}
                    />
                </div>

                <div className='details-wrapper'>
                    <p className='message-sent-header'>
                        {translations.messageSentHeader}
                    </p>
                    <p className='message-sent-sub-header'>
                        {translations.messageSentSubheader}
                    </p>
                </div>

                <Button
                    className='gradient-180 button'
                    style={ButtonStyles.Primary}
                    variant={ButtonVariants.Primary}
                    layout={ButtonLayouts.Block}
                    size={ButtonSizes.Medium}
                    onClick={returnToHome}
                >
                    {translations.returnToHomeButton}
                </Button>

                <Button
                    style={ButtonStyles.TextCTA}
                    size={ButtonSizes.Small}
                    onClick={returnToForm}
                >
                    {translations.returnToFormButton}
                </Button>
            </div>
        </StyledComponent>
    );
};

export default MessageSent;
